import { ApprovalConsiderationAnnounceNineContainer } from '../../../containers/SupportSystem/ReportOnApprovalConsiderationResults/ApprovalConsiderationAnnounceNineContainer';

export function ApprovalConsiderationAnnounceNinePage() {
    return (
        <ApprovalConsiderationAnnounceNineContainer />
    )
}